import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { TaxonomyManager } from "./admin.categories";

export const Route = createFileRoute("/admin/tags")({
  component: TagsPage,
  head: () => ({ meta: [{ title: "Tags — Admin" }, { name: "robots", content: "noindex" }] }),
});

function TagsPage() {
  return (
    <AdminLayout title="Tags">
      <TaxonomyManager table="tags" labelSingular="Tag" labelPlural="Tags" />
    </AdminLayout>
  );
}
